import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

class InfoMessage extends Component {
  redirectToIndex = () => {
    const { history } = this.props;
    history.push('/');
  };

  render() {
    const { type, t } = this.props;

    return (
      <div name='info-msg-container' className='info-msg-container'>
        <div className='row'>
          <div className='col-md-10 offset-md-1 col-xl-8 offset-xl-2'>
            <div className='msg'>
              {type === 'notfound' && [
                <h1 key='title'>{t('infoMessage.notFound')}</h1>,
                <button key='link' className='btn btn-lg btn-success mt-5 text-uppercase' onClick={this.redirectToIndex}>{t('infoMessage.action')}</button>,
              ]}
              {
                type === 'error' && <Fragment>
                  <h1>{t('infoMessage.error_1')}</h1>
                  <p>{t('infoMessage.error_2')} <a href='tel:800922200'>800.92.22.00</a> {t('infoMessage.error_3')}</p>
                </Fragment>
              }
              {
                type === 'loading' && <Fragment>
                  <p>{t('infoMessage.loading')}</p>
                </Fragment>
              }
              {
                type === 'confirm' && <Fragment>
                  <p>{t('infoMessage.confirm_1')}</p>
                  <p>{t('infoMessage.confirm_2')}</p>
                </Fragment>
              }
              {
                type === 'active' && <p>{t('infoMessage.active_1')} <a href='tel:800922200'>800.92.22.00</a> {t('infoMessage.active_2')}</p>
              }
            </div>
          </div>
        </div>
      </div>
    );
  }
}

InfoMessage.propTypes = {
  type: PropTypes.string,
  history: PropTypes.object,
  t: PropTypes.func
};

export default withRouter(InfoMessage);
